module.exports = __webpack_public_path__ + "static/Karen-e81ee2f14b661586c9786a26939f9173.jpg";